import { Controller } from 'react-hook-form';
import classNames from 'classnames';
import Label from '../Label';
import { Slider, Tooltip, styled } from '@mui/material';
var CustomTooltip = function (props) {
    var children = props.children, value = props.value;
    return (<Tooltip enterTouchDelay={0} placement="top" title={value} arrow>
      {children}
    </Tooltip>);
};
var CustomSlider = styled(Slider)(function (_a) {
    var theme = _a.theme;
    return ({
        color: '#FDC300',
        '& .MuiSlider-thumb': {
            backgroundColor: '#FFF',
            border: '3px solid #FDC300',
        },
        '& .MuiSlider-rail': {
            color: '#D2D1DB',
            opacity: 1,
        },
    });
});
var RangeSlider = function (_a) {
    var name = _a.name, label = _a.label, control = _a.control, defaultValue = _a.defaultValue, min = _a.min, max = _a.max, _b = _a.step, step = _b === void 0 ? 10 : _b, _c = _a.unit, unit = _c === void 0 ? 'km' : _c, _d = _a.required, required = _d === void 0 ? true : _d;
    return (<div className={classNames('flex w-full flex-col gap-6')}>
      {label && <Label label={label} htmlFor={name} required={required}/>}
      <div className="flex flex-col gap-2">
        <Controller control={control} name={name} defaultValue={defaultValue} render={function (_a) {
            var field = _a.field;
            return (<CustomSlider {...field} aria-label={label} onChange={function (e, newValue) { return field.onChange(newValue); }} valueLabelDisplay="auto" components={{
                    ValueLabel: CustomTooltip,
                }} valueLabelFormat={function (value) { return "".concat(value, " ").concat(unit); }} min={min} max={max} step={step} disableSwap/>);
        }}/>
        <div className="flex justify-between">
          <div className="text-xs">{"".concat(min, " ").concat(unit)}</div>
          <div className="text-xs">{"".concat(max, " ").concat(unit)}</div>
        </div>
      </div>
    </div>);
};
export default RangeSlider;
